import { Question, SvgRegistry } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { AppWysiwygEditor } from '../../../core-components/wysiwyg/Tiptap';

SvgRegistry &&
  SvgRegistry.registerIconFromSvg(
    'icon-editor',
    `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><rect fill="none" height="24" width="24"/><path d="M3,10h11v2H3V10z M3,8h11V6H3V8z M3,16h7v-2H3V16z M18.01,12.87l0.71-0.71c0.39-0.39,1.02-0.39,1.41,0l0.71,0.71 c0.39,0.39,0.39,1.02,0,1.41l-0.71,0.71L18.01,12.87z M17.3,13.58l-5.3,5.3V21h2.12l5.3-5.3L17.3,13.58z"/></svg>`,
    ''
  );

const CUSTOM_TYPE = 'editor';

// Create a question model
export class QuestionEditorModel extends Question {
  get height() {
    return this.getPropertyValue('height');
  }

  set height(val) {
    this.setPropertyValue('height', val);
  }

  getType() {
    return CUSTOM_TYPE;
  }
}

// Create a class that renders the editor
export class SurveyEditorWidget extends SurveyQuestionElementBase {
  constructor(props: unknown) {
    super(props);
  }

  get question() {
    return this.questionBase;
  }

  get value() {
    return this.question.value;
  }

  handleValueChange = (val: unknown) => {
    this.question.value = val;
  };

  // Support the read-only and design modes
  get style() {
    return { minHeight: this.question.height };
  }

  renderEditor() {
    const isReadOnly = this.question.isReadOnly || this.question.isDesignMode;

    // Render the wrapper functional component
    return (
      <AppWysiwygEditor
        id={this.question.id + '-' + this.question.name}
        disabled={isReadOnly}
        value={this.value}
        setValue={(value: string) => {
          this.handleValueChange(value);
        }}
      />
    );
  }

  renderElement() {
    return (
      <div id="spg-editor" style={this.style}>
        {this.renderEditor()}
      </div>
    );
  }
}
